import React, {Component} from 'react';
import {connect} from "react-redux";
import {clickedNodeAction} from "../../../../actions/clickedNodeActions";

import ContextPropertyModifier from "../ContextPropertyInputPortList/ContextPropertyModifier";
import {
    updateContextUpdater,
    updateUpdaterContextProperty
} from "../../../../actions/contextUpdaterActions";
import ContentWithTopLabel from "../ContentWithTopLabel";
import InputWithLabel from "../InputWithLabel";
import {OverwriteDynamicPropertyCheckbox} from "../InputPortListUtils/components/OverwriteDynamicPropertyCheckbox";
import Predicate from "../Predicate";
import defaultPredicateOption from "../Predicate/const/defaultPredicateOption";

const switchDefaultPredicateOption = defaultPredicateOption;

class ContextPropertyEditor extends Component {
    constructor(props) {
        super(props);
        const updaterIndex = this.props.updaterIndex;
        const updaterEntry = this.props.contextUpdaters[updaterIndex].data?.idValue;
        this.hasFuncs = this.props.clickedNodeInfo.extras.options && updaterEntry;
        this.state = {
            conditionalModifier: this.hasFuncs ? updaterEntry.conditionalModifier : {
                modifier: {
                    funcName: "concat",
                    funcArgs: []
                },
                predicate: {
                    type: "and",
                    predicates: [
                        switchDefaultPredicateOption
                    ],
                    alwaysTrue: false
                }
            },
            compositeFieldName: this.props.contextUpdaters[updaterIndex].data?.compositeFieldName,
            elementIdAutoIncrement: this.hasFuncs ? updaterEntry.elementIdAutoIncrement : 0,
            shouldOverwriteContextPropertyIfExists: this.hasFuncs ? updaterEntry.shouldOverwriteContextPropertyIfExists : true,
            shouldSuffixContextPropertyIfSplitIsUsed: this.hasFuncs ? updaterEntry.shouldSuffixContextPropertyIfSplitIsUsed : false
        };

        this.updateProperty = this.updateProperty.bind(this);
        this.updateOptions = this.updateOptions.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.updateOptionFieldName = this.updateOptionFieldName.bind(this);
    }

    updateOptions(type, value) {
        this.setState({
            ...this.state,
            conditionalModifier: {
                ...this.state.conditionalModifier,
                [type]: value
            }
        }, () => {
            this.props.updateContextUpdater(this.props.updaterIndex, "idValue", this.state)
        });
    }

    updateProperty(property, value) {
        this.setState({
            [property]: value
        });
        this.props.updateContextUpdater(this.props.updaterIndex, "idValue", this.state);
        this.props.updateContextUpdater(this.props.updaterIndex, property, value);
    }

    onCheck(propName, e)  {
        const value = e.target.checked;
        this.state.updateProperty(propName, value);
    }

    updateOptionFieldName = (property, e) => {
        const value = e.target.value;
        this.setState({
            [property]: value
        });
        this.updateProperty(property, value)
    }

    render() {
        return (
            <>
                <ContentWithTopLabel label="Field name">
                    <InputWithLabel
                        label="New Context property name:"
                        handleChange={e => this.updateOptionFieldName('compositeFieldName', e)}
                        value={this.state.compositeFieldName}
                    />
                    <OverwriteDynamicPropertyCheckbox
                        isChecked={this.state.shouldOverwriteContextPropertyIfExists}
                        onCheck={e => this.onCheck('shouldOverwriteContextPropertyIfExists', e)}
                        name={"shouldOverwriteContextPropertyIfExists"}
                        label={"Should Overwrite Context Property If Exists"}
                    />
                    <OverwriteDynamicPropertyCheckbox
                        isChecked={this.state.shouldSuffixContextPropertyIfSplitIsUsed}
                        onCheck={e => this.onCheck('shouldSuffixContextPropertyIfSplitIsUsed', e)}
                        name={"shouldSuffixContextPropertyIfSplitIsUsed"}
                        label={"Should Suffix Context Property If Split Is Used"}
                    />
                </ContentWithTopLabel>
                <ContentWithTopLabel label="Modifiers"/>
                <Predicate
                    updateOptions={(predicate) => this.updateOptions("predicate", predicate)}
                    predicate={this.state.conditionalModifier.predicate}
                    predicateBlockType={"context_updater"}
                />
                <ContextPropertyModifier
                    updateOptions={(funcName) => this.updateOptions("modifier", funcName)}
                    modifier={this.state.conditionalModifier.modifier}
                    compositeFieldName={this.state.compositeFieldName}
                    updateProperty={this.updateProperty}
                    elementIdAutoIncrement={this.state.elementIdAutoIncrement}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        contextUpdaters: state.contextUpdaters,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {updateContextUpdater, updateUpdaterContextProperty, clickedNodeAction})(ContextPropertyEditor);